import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const DISMISS_KEY = "sto-exporter-award-2026-banner-dismissed";
// Goes live 6:00 AM St. Kitts time (UTC-4) on 26 October 2026.
const LIVE_AT = new Date("2026-10-26T10:00:00Z");

const AnnouncementBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (new Date() < LIVE_AT) return;
    try {
      setVisible(localStorage.getItem(DISMISS_KEY) !== "1");
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
  };

  if (!visible) return null;

  return (
    <div className="relative bg-primary text-primary-foreground py-2.5 px-10 text-center text-sm font-sans">
      <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-1.5 sm:flex-row sm:gap-3">
        <p className="leading-snug">
          We've been named <strong>Small Exporter of the Year 2026</strong> by the St. Kitts and
          Nevis Chamber of Industry and Commerce — our seventh business award.
        </p>
        <Link
          to="/blog/small-exporter-of-the-year-2026"
          className="whitespace-nowrap rounded-full border border-primary-foreground/40 bg-primary-foreground/10 px-3 py-1 text-xs font-medium tracking-wide transition-colors hover:bg-primary-foreground/20"
        >
          Read the Story
        </Link>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss announcement"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 transition-colors hover:bg-primary-foreground/15"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
